import { useTranslation } from 'react-i18next';
import { ApplicationStatus } from '../types';

interface Props {
    status: ApplicationStatus;
    size?: 'sm' | 'md';
}

const ApplicationStatusBadge = ({ status, size = 'md' }: Props) => {
    const { t } = useTranslation('member-management');

    const translateStatus = (status: ApplicationStatus) => {
        switch (status) {
            case 'requested':
                return t('applications.status.requested');

            case 'accepted':
                return t('applications.status.accepted');

            case 'declined':
                return t('applications.status.declined');

            default:
                return '-';
        }
    };
    return (
        <span
            className={`tw-rounded-xl ${size === 'sm' ? 'tw-px-2 tw-py-1 tw-text-xs' : 'tw-px-4 tw-py-2'} ${status === 'requested' && 'tw-bg-warning tw-text-warningLight'} ${status === 'declined' && 'tw-bg-red-500 tw-text-red-50'} ${status === 'accepted' && 'tw-bg-success tw-text-successLight'}`}
        >
            {translateStatus(status)}
        </span>
    );
};

export default ApplicationStatusBadge;
